'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollUnlock = exports.scrollLock = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollLock = exports.scrollLock = function scrollLock() {
  $.scrollLock(true);
};

var scrollUnlock = exports.scrollUnlock = function scrollUnlock() {
  $.scrollLock(false);
};